import { Controller } from 'stimulus'

// "+N more" / "Show fewer" for server-rendered chip lists (Settings ->
// Job Fields details column). The extra chips are already in the page,
// just hidden — no fetch.
export default class extends Controller {
  static targets = ['extra', 'button']

  toggle() {
    const expanded = !this.extraTarget.classList.toggle('hidden')
    this.buttonTarget.textContent = expanded ? 'Show fewer' : this.buttonTarget.dataset.moreLabel
  }
}
